function isBlank(str) {
  return (!str || /^(?=\s*$)/.test(str));
}

function cleanBaseUrl(base_url_str) {
  if (isBlank(base_url_str)) {
    throw new Error('Base URL is blank: ' + base_url_str);
  }
    // remove trailing slash in case
    return base_url_str.replace(/\/+$/, '')
}

function getRuntimeValue(key) {
  if (typeof window !== 'undefined' &&
      window.__RUNTIME_CONFIG__ &&
      !isBlank(window.__RUNTIME_CONFIG__[key])) {
    return window.__RUNTIME_CONFIG__[key];
  }
  return null;
}

export const BASE_BACKEND_URL = cleanBaseUrl(
  getRuntimeValue('PUBLIC__API_SERVER_URL') ||
  process.env.NEXT_PUBLIC_API_SERVER_URL ||
  process.env.REACT_APP_API_SERVER_URL );

export const DATA_RETRIEVAL_BASE_URL = cleanBaseUrl(
  getRuntimeValue('PUBLIC__DATA_RETRIEVAL_URL') ||
  process.env.NEXT_PUBLIC_DATA_RETRIEVAL_URL ||
  process.env.REACT_APP_DATA_RETRIEVAL_URL );